import React from "react";
import "./index.scss";

export const CheckEmailProceed = () => {
    return (
        <section>
            <div className="check-proceed">
                <div className="check-proceed_head">
                    <img src="/assets/logo.svg" alt="logo"/>
                </div>

                <div className="check-proceed_body">
                    <div className="check-proceed_body_content">
                        <h3 className="check-proceed_text-title">Check Your Email to Proceed</h3>

                        <div className="check-proceed_body_content_img">
                            <img src="/assets/images/check-email-proceed.png" alt=""/>
                        </div>

                        <div className="check-proceed_body_content_steps">
                            <div className="check-proceed_text-secondary">If you’re setting up your account for the
                                first time:
                            </div>
                            <div className="check-proceed_text-primary text_background">1. Go to your email inbox and
                                locate the email
                                we just sent you.
                            </div>
                            <div className="check-proceed_text-primary text_background">2. Click the button in the email
                                to securely
                                access your account setup page.
                            </div>
                            <div className="check-proceed_text-primary text_background">3. Create your password after
                                clicking the
                                button in the email.
                            </div>
                        </div>

                        <div className="divider">
                            <div className="divider_line"></div>
                            <div className="divider_text">OR</div>
                            <div className="divider_line"></div>
                        </div>

                        <div className="check-proceed_body_content_steps">
                            <div className="check-proceed_text-secondary">If you already have an account:</div>
                            <div className="check-proceed_text-primary">
                                You can <u className="check-proceed_text-link"><a href="/login" style={{color: '#23262F'}}>log in</a></u> directly using the password you created. If you’ve forgotten your
                                password, you can reset it by selecting the “Forgot Password?” option on the login page.
                            </div>
                        </div>

                        <div className="divider">
                            <div className="divider_line"></div>
                        </div>

                        <div className="check-proceed_body_content_steps">
                            <div className="check-proceed_text-secondary">Didn’t receive the email?</div>
                            <div className="check-proceed_text-primary">
                                Check your spam or junk folder. If it’s not there, press the button again to resend the email.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};